import { useCallback } from "react";
import { userOrderInfoBannerMinimizedPath } from "../../functions/src/admin/paths";
import { mainDatabase } from "../api/firebase";
import { useDatabase } from "../api/firebaseHooks";

export function useOrderInfoBannerMinimized(uid: string | undefined, schoolKey: string | undefined) {
    const path = uid && schoolKey ? userOrderInfoBannerMinimizedPath(uid, schoolKey) : null;
    const snap = useDatabase(path);
    const minimized = snap?.val() === true;

    const dismiss = useCallback(() => {
        if (!path) {
            return;
        }
        void mainDatabase.ref(path).set(true).catch((err) => console.warn("Failed to save order info banner preference:", err));
    }, [path]);

    const restore = useCallback(() => {
        if (!path) {
            return;
        }
        void mainDatabase.ref(path).remove().catch((err) => console.warn("Failed to save order info banner preference:", err));
    }, [path]);

    return { minimized, dismiss, restore };
}
